import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Sitemap() {
  useEffect(() => {
    document.title = 'Sitemap | Evolve Media Agency';
    const link = document.querySelector("link[rel='canonical']") || document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', 'https://evolvemediaagency.com/sitemap');
    if (!document.querySelector("link[rel='canonical']")) document.head.appendChild(link);
  }, []);

  const pages = [
    { path: "/", title: "Home", description: "Amazon & ecommerce content creation services" },
    { path: "/video-portfolio", title: "Video Portfolio", description: "Our product video work and client examples" },
    { path: "/product-photos", title: "Product Photos", description: "Professional Amazon product photography portfolio" },
    { path: "/ai", title: "AI Photoshoot", description: "AI-powered product photography service" },
    { path: "/amazon-product-video-production", title: "Amazon Product Video Production", description: "Complete guide to the 6 types of Amazon product videos and why video increases conversion rates" },
    { path: "/amazon-brand-store-design", title: "Amazon Brand Store Design", description: "How to build a storefront that converts with the right layouts, navigation, and content" },
    { path: "/ecommerce-content-roi", title: "Ecommerce Content ROI", description: "The real math on professional content investment vs. PPC savings and conversion gains" },
    { path: "/custom-jingles-sonic-branding", title: "Custom Jingles & Sonic Branding", description: "Listen to 63 original custom jingles produced for Amazon and ecommerce brands" },
    { path: "/shopify-web-development", title: "Shopify & Web Development", description: "Stores, landing pages, and sales funnels engineered for CTR and CVR" },
    { path: "/content", title: "Full-Service Content Production", description: "Photo, video, music, web, design, copy, email, and paid ads — every piece of content your brand needs from one team" },
    { path: "/blog", title: "Blog", description: "Amazon selling tips and ecommerce insights" },
  ];

  const blogPosts = [
    { path: "/blog/generative-engine-optimization-geo-2026", title: "GEO Playbook (2026)", description: "How to get ChatGPT to recommend your brand" },
    { path: "/blog/how-to-get-chatgpt-to-recommend-your-product", title: "Get ChatGPT to Recommend Your Product", description: "Step-by-step GEO framework" },
    { path: "/blog/track-ai-brand-mentions-tools-2026", title: "Track AI Brand Mentions", description: "6 tools and methods that actually work" },
    { path: "/blog/geo-for-amazon-sellers-2026", title: "GEO for Amazon Sellers", description: "Win generative engine optimization on Amazon" },
    { path: "/blog/amazon-a-plus-content-guide-2026", title: "A+ Content Design Guide (2026)", description: "How to design A+ modules that increase conversions" },
    { path: "/blog/ai-product-photography-vs-traditional-2026", title: "AI vs. Traditional Product Photography", description: "Honest comparison with cost breakdowns and compliance guidance" },
    { path: "/blog/amazon-product-launch-strategy-2026", title: "Amazon Product Launch Playbook", description: "Complete step-by-step launch strategy" },
    { path: "/blog/amazon-product-research-2026", title: "Amazon Product Research Guide", description: "How to find profitable products to sell" },
    { path: "/blog/amazon-listing-optimization-guide-2026", title: "Listing Optimization Guide", description: "Optimize your Amazon listings for maximum conversion" },
    { path: "/blog/amazon-ppc-strategy-2026", title: "Amazon PPC Strategy", description: "PPC campaign structure and optimization" },
    { path: "/blog/email-marketing-amazon-sellers-2026", title: "Amazon Email Marketing", description: "Building an email list and driving repeat purchases" },
    { path: "/blog/amazon-conversion-rate-optimization-2026", title: "Conversion Rate Optimization", description: "Diagnose and fix low conversion rates" },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4 text-center">
            Sitemap
          </h1>
          <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">
            Browse all pages on Evolve Media Agency
          </p>

          <h2 className="text-2xl font-bold text-foreground mb-6">Pages & Guides</h2>
          <div className="space-y-6 mb-12">
            {pages.map((page) => (
              <Link
                key={page.path}
                to={page.path}
                className="block p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow border-l-4 border-cta-blue hover:border-cta-green"
              >
                <h3 className="text-xl font-bold text-foreground mb-2">
                  {page.title}
                </h3>
                <p className="text-muted-foreground mb-2">{page.description}</p>
                <p className="text-sm text-cta-blue font-semibold">
                  evolvemediaagency.com{page.path}
                </p>
              </Link>
            ))}
          </div>

          <h2 className="text-2xl font-bold text-foreground mb-6">Blog Posts</h2>
          <div className="space-y-4 mb-12">
            {blogPosts.map((post) => (
              <Link
                key={post.path}
                to={post.path}
                className="block p-5 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow border-l-4 border-cta-green hover:border-cta-blue"
              >
                <h3 className="text-lg font-bold text-foreground mb-1">
                  {post.title}
                </h3>
                <p className="text-muted-foreground text-sm mb-1">{post.description}</p>
                <p className="text-xs text-cta-blue font-semibold">
                  evolvemediaagency.com{post.path}
                </p>
              </Link>
            ))}
          </div>

          <div className="mt-12 p-6 bg-section-light rounded-lg">
            <h3 className="text-xl font-bold text-foreground mb-4">Evolve Media Network</h3>
            <ul className="space-y-3 mb-6">
              <li>
                <a href="https://evolveamz.com/" target="_blank" rel="noopener noreferrer" className="text-cta-blue hover:underline">
                  🌐 EvolveAMZ.com — Full-service Amazon agency
                </a>
              </li>
              <li>
                <a href="https://evolvemedia.agency/" target="_blank" rel="noopener noreferrer" className="text-cta-blue hover:underline">
                  🎨 EvolveMedia.Agency — Creative network
                </a>
              </li>
              <li>
                <a href="https://evolveamz.com/custom-jingles/" target="_blank" rel="noopener noreferrer" className="text-cta-blue hover:underline">
                  🎵 EvolveAMZ — Custom Jingles service
                </a>
              </li>
              <li>
                <a href="https://evolveamz.com/web-development/" target="_blank" rel="noopener noreferrer" className="text-cta-blue hover:underline">
                  💻 EvolveAMZ — Web Development service
                </a>
              </li>
            </ul>

            <h3 className="text-xl font-bold text-foreground mb-4">External Resources</h3>
            <ul className="space-y-3">
              <li>
                <a href="https://evolveamz.com/ecom-growth-guides/" target="_blank" rel="noopener noreferrer" className="text-cta-blue hover:underline">
                  📚 Free Ecommerce Growth Guides
                </a>
              </li>
              <li>
                <a href="https://www.digitalmarketer.com/ebooks/customer-avatar-worksheet-download/" target="_blank" rel="noopener noreferrer" className="text-cta-blue hover:underline">
                  🎯 Customer Avatar Worksheet
                </a>
              </li>
              <li>
                <a href="https://calendly.com/evolvemedia/amz-30-min" target="_blank" rel="noopener noreferrer" className="text-cta-blue hover:underline">
                  📅 Book a Free Brand Audit
                </a>
              </li>
              <li>
                <a href="https://evolvemedia.agency/pricing" target="_blank" rel="noopener noreferrer" className="text-cta-blue hover:underline">
                  💰 View Pricing
                </a>
              </li>
            </ul>
          </div>

          <div className="mt-8 text-center">
            <a href="/sitemap.xml" className="text-sm text-muted-foreground hover:text-cta-blue transition">
              View XML Sitemap
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}